import React, { useState, useEffect } from 'react';
import styled, { css, keyframes, useTheme } from 'styled-components';
import { radius } from '@/styles/template';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const Placeholder = styled.div<{ loaded: boolean; theme: any }>`
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  border-radius: ${radius.normal};
  
  background-image: 
		  linear-gradient(90deg, ${props => props.theme.color.Background} 25%, 
		  ${props => props.theme.color.Item} 50%, 
		  ${props => props.theme.color.Background} 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 2s infinite;
  position: relative;

  ${({ loaded }) => loaded && css`
    background-color: transparent;
    background-image: none;
    animation: none;
    padding-top: 0;
  `}
`;

const StyledImage = styled.img<{ loaded: boolean }>`
  width: 100%;
  height: auto;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;

  ${({ loaded }) => loaded && css`
    position: relative;
    opacity: 1;
  `}
`;

type LazyImageProps = {
	src: string;
	alt: string;
};

const LazyImage: React.FC<LazyImageProps> = ({ src, alt  }) => {
	const [loaded, setLoaded] = useState(false);
	const theme = useTheme();

	useEffect(() => {
		const img = new Image();
		img.src = src;
		img.onload = () => setLoaded(true);
	}, [src]);

	return (
		<Placeholder loaded={loaded} theme={theme}>
			<StyledImage src={src} alt={alt} loaded={loaded} />
		</Placeholder>
	);
};

export default LazyImage;
